import React, { FC, useEffect, useState } from 'react';
import RoutesConfig from './shared/routes/RoutesConfig';
import { ThemeProvider } from './shared/context/ThemeContext';
import { useAuth } from './shared/hooks/useAuth';
import { usePageOverflow } from './shared/hooks/usePageOverflow';
import { AnimatePresence } from 'framer-motion';
import BaseLayout from './shared/ui/base-layout/BaseLayout';
import { useSelector } from 'react-redux';
import { useAppDispatch } from './store/store';
import {
    selectIsAuthenticated,
    selectUser,
    selectUserProfile,
} from './store/selectors/authSelectors';
import { useLocation } from 'react-router-dom';
import { fetchUserProfile, fetchCurrentUser } from './shared/api/authApi';
import { ToastContainer } from 'react-toastify';
import Loader from './shared/ui/loader/Loader';
import { fetchSubscriptionProducts, fetchUserSubscription } from './store/slices/subscriptionSlice';
import { selectProducts, selectUserSubscription } from './store/selectors/subscriptionSelector';

const App: FC = () => {
    const dispatch = useAppDispatch();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const user = useSelector(selectUser);
    const userProfile = useSelector(selectUserProfile);
    const location = useLocation();
    const [isLoadingUser, setIsLoadingUser] = useState(false);
    const products = useSelector(selectProducts);
    const userSubscription = useSelector(selectUserSubscription);

    useAuth();
    usePageOverflow();

    useEffect(() => {
        const fetchUser = async () => {
            if (isAuthenticated) {
                setIsLoadingUser(true);
                if (!user?.id) {
                    await dispatch(fetchCurrentUser());
                    setIsLoadingUser(false);
                }
            }
        };
        fetchUser();
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        if (!products || products.length === 0) {
            dispatch(fetchSubscriptionProducts());
        }
        // if (!userSubscription) {
        //     dispatch(fetchUserSubscription());
        // }
    }, [dispatch]);

    useEffect(() => {
        if (user && !userProfile && location.pathname !== '/auth') {
            dispatch(fetchUserProfile(user.id));
            dispatch(fetchUserSubscription());
        }
    }, [user]);

    return (
        <ThemeProvider>
            <AnimatePresence>
                <BaseLayout>
                    <RoutesConfig />
                    <ToastContainer
                        position="bottom-right"
                        hideProgressBar={true}
                        closeOnClick={true}
                        closeButton={false}
                    />
                </BaseLayout>
            </AnimatePresence>
        </ThemeProvider>
    );
};

export default App;
